import userApi from '@/api/user';

const state = {
    user: null,
    key: null,
    permissions: [],
};

const actions = {
    async loginDialog({ dispatch }) {
        swal({
            title: 'Log In',
            text: 'Enter your PIN',
            input: 'text',
            inputAttributes: {
                // Using a real password field here makes Chrome prompt the user to save the password.
                // Instead, we'll use a normal text field and obscure the text wtih -webkit-text-security.
                'style': '-webkit-text-security: disc;',
                'autocapitalize': 'off',
                'autocorrect': 'off'
            },
            confirmButtonText: 'Log In',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async (pin) => {
                try {
                    await dispatch('login', { pin });
                } catch (e) {
                    // Throwing here rejects the dialog promise, which closes the
                    // dialog and is then swallowed by the .catch(swal.noop)
                    // below, so a mistyped PIN gave no feedback at all.
                    // showValidationMessage keeps the dialog open and renders the
                    // reason, which is what this always meant to do.
                    swal.showValidationMessage('Invalid PIN, please try again');
                }
            },
        }).catch(swal.noop);
    },
    async login({ commit }, { pin }) {
        let data = await userApi.findByPin(pin);
        commit('SOFT_LOGIN', data);
        window.axios.defaults.headers.common['Soft-Login-User-Key'] = data.key;
    },
    logout({ commit }) {
        commit('SOFT_LOGOUT');
        delete window.axios.defaults.headers.common['Soft-Login-User-Key'];
    },
};

const mutations = {
    SOFT_LOGIN(state, { user, key }) {
        state.user = user;
        state.key = key;
        state.permissions = user.all_permissions;
    },
    SOFT_LOGOUT(state) {
        state.user = null;
        state.key = null;
        state.permissions = [];
    },
};

export default {
    state,
    actions,
    mutations,
    namespaced: true,
};
